import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  base: css`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);
    align-items: flex-start;
    width: 100%;
  `,
  labelPillRow: css`
    display: flex;
    align-items: center;
    gap: var(--spacing-8);
    padding-top: calc(var(--font-line-height-body) + var(--spacing-4));
  `,
  label: css`
    ${kitText.style.bold}
    ${kitText.variant.body}
    white-space: nowrap;
  `,
  pillGroup: css`
    display: inline-grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: var(--spacing-2);
    padding: var(--spacing-4);
    border: 1px solid var(--color-border-primary);
    border-radius: 9999px;
    background: var(--color-background-tertiary);
  `,
  segment: css`
    ${kitText.variant.micro}
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 var(--spacing-4);
    cursor: pointer;
    user-select: none;
    color: var(--color-secondary);
    border-radius: 9999px;
    transition:
      background 0.15s ease,
      color 0.15s ease;

    &:has(input:focus-visible) {
      box-shadow: 0 0 0 2px var(--color-splash-primary);
    }
    &:has(input:enabled):hover {
      background: #e7e9ef;
    }
  `,
  segmentSelected: css`
    background: var(--color-splash-primary);
    color: var(--white);
    &:has(input:enabled):hover {
      background: var(--color-splash-primary);
    }
  `,
  segmentReadonly: css`
    cursor: default;
  `,
  segmentDisabled: css`
    cursor: not-allowed;
    opacity: 0.5;
  `,
  hiddenInput: css`
    all: unset;
  `,
  description: css`
    ${kitText.color.secondary}
    ${kitText.variant.body}
  `
};
